import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface MembershipFAQProps {
  title: string;
  items: {
    q: string;
    a: string;
  }[];
}
export function MembershipFAQ({
  title,
  items
}: MembershipFAQProps) {
  const [open, setOpen] = useState<number | null>(null);
  return <div className="mt-20" data-id="element-273" data-mp="1blno3q3fp1o6">
      <h3 className="font-display text-2xl font-bold text-navy" data-id="element-274" data-mp="xw2bqyk53kp4">{title}</h3>
      <dl className="mt-6 grid gap-x-10 border-t border-navy/10 md:grid-cols-2" data-id="element-275" data-mp="xur5ms3820uu">
        {items.map((item, index) => {
        const expanded = open === index;
        return <div key={item.q} className="border-b border-navy/10" data-id="element-276" data-mp="nzh8oirokjnx" data-mpi={index}>
              <dt data-id="element-277" data-mp="sw7n71nu7778">
                <button type="button" onClick={() => setOpen(expanded ? null : index)} aria-expanded={expanded} className="flex w-full items-center justify-between gap-4 py-4 text-left" data-id="element-278" data-mp="sxr4mvl8boal">
                  <span className="text-sm font-semibold text-navy sm:text-base" data-id="element-279" data-mp="ouwhxl4tvtjh">{item.q}</span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-ink/50 transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-280" data-mp="kuud533sqjzz" />
                </button>
              </dt>
              <AnimatePresence initial={false} data-id="element-281" data-mp="667zd5tti0av">
                {expanded && <motion.dd initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-282" data-mp="16llqva2ui1j">
                    <p className="pb-4 text-sm leading-relaxed text-ink/70" data-id="element-283" data-mp="3jii043s895zq">{item.a}</p>
                  </motion.dd>}
              </AnimatePresence>
            </div>;
      })}
      </dl>
    </div>;
}